module.exports = __webpack_public_path__ + "img/fin_ill_2.07564a3f.png";